import React, { useEffect, useState } from 'react'
import { useGetTeamsQuery } from '../features/team/teamApi'
import { useGetProjectsQuery } from '../features/project/projectApi'
import { useNavigate } from 'react-router-dom'
import { useUpdateTaskMutation } from '../features/task/taskApi'

export default function EditTaskForm({ task }) {
    const navigate = useNavigate()
    const { isSuccess: isSuccessTeams, data: teams } = useGetTeamsQuery()
    const { isSuccess: isSuccessProjects, data: projects, } = useGetProjectsQuery()
    const [updateTask, { }] = useUpdateTaskMutation()

    const { taskName: defaultTaskName, teamMember: defaultTeamMember, project: defaultProject, deadline: defaultDeadline, status } = task || {}

    const [taskName, setTaskName] = useState(defaultTaskName)
    const [teamMember, setTeamMember] = useState(JSON.stringify(defaultTeamMember))
    const [project, setProject] = useState(JSON.stringify(defaultProject))
    const [deadline, setDeadline] = useState(defaultDeadline)

    useEffect(() => {

    }, [])


    function handleSubmit(e) {
        e.preventDefault();

        updateTask({
            ...task,
            taskName,
            teamMember: JSON.parse(teamMember),
            project: JSON.parse(project),
            deadline,
            status: status ? status : ""
        })
    }

    return (
        <form onSubmit={handleSubmit} className="space-y-6">
            <div className="fieldContainer">
                <label htmlFor="lws-taskName">Task Name</label>
                <input
                    type="text"
                    name="taskName"
                    id="lws-taskName"
                    required
                    value={taskName}
                    onChange={e => setTaskName(e.target.value)}
                    placeholder="Implement RTK Query"
                />
            </div>

            <div className="fieldContainer">
                <label>Assign To</label>
                <select name="teamMember" id="lws-teamMember" value={teamMember} onChange={e => setTeamMember(e.target.value)} required>
                    <option value="" hidden selected>Select Job</option>
                    {
                        isSuccessTeams && teams.length > 0 ? teams.map(team => <option key={team.id} value={JSON.stringify(team)}>{team.name}</option>) : "Loading..."
                    }
                </select>
            </div>
            <div className="fieldContainer">
                <label htmlFor="lws-projectName">Project Name</label>
                <select id="lws-projectName" name="projectName" value={project} onChange={e => setProject(e.target.value)} required>
                    <option value="" hidden selected>Select Project</option>
                    {
                        isSuccessProjects && projects.length > 0 ? projects.map(project => <option key={project.id} value={JSON.stringify(project)}>{project.projectName}</option>) : "Loading..."
                    }
                </select>
            </div>

            <div className="fieldContainer">
                <label htmlFor="lws-deadline">Deadline</label>
                <input type="date" name="deadline" id="lws-deadline" value={deadline} onChange={e => setDeadline(e.target.value)} required />
            </div>

            <div className="text-right">
                <button type="submit" className="lws-submit">Save</button>
            </div>
        </form>
    )
}
